import { Component, OnInit } from '@angular/core';
import {
  IsiClientReportDetail, ISICountryWiseEntity,
  ISICountryWisePerson,
  IsiPersonReportDetail,
  ISIstructureWiseEntity
} from '../isi-report-detail/isi-report-detail.model';
import {ReportsService} from '../reports.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-isi-report-detail-suboffices',
  templateUrl: './isi-report-detail-suboffices.component.html',
  styleUrls: ['./isi-report-detail-suboffices.component.css'],
  providers: [ReportsService]
})
export class IsiReportDetailSubofficesComponent implements OnInit {
  subOfficeId: any;
  public allClient = new IsiClientReportDetail;
  public lowRiskBasedDV = new IsiClientReportDetail;
  public mediumRiskBasedDV = new IsiClientReportDetail;
  public highRiskBasedDV = new IsiClientReportDetail;
  public clientAtYearStart = new IsiClientReportDetail;
  public offBoardedClients = new IsiClientReportDetail;
  public newClientsAtYear = new IsiClientReportDetail;
  public clientAtYearEnd = new IsiClientReportDetail;
  public clientFromNetherland = new IsiClientReportDetail;
  public clientNotFromNetherland = new IsiClientReportDetail;
  public uboFromNetherland = new IsiPersonReportDetail;
  public uboNotFromNetherland = new IsiPersonReportDetail;
  uboPeps = new IsiPersonReportDetail;
  privateStructure = new IsiClientReportDetail;
  bfiClient = new IsiClientReportDetail;

  fiveLayersClient = new IsiClientReportDetail;
  dVWithNomineeShareholders = new ISIstructureWiseEntity;
  dvWithTrustOfficeAsNomineeShareholder = new IsiClientReportDetail;
  dvWithCVOrAlike = new ISIstructureWiseEntity;
  cvOrAlike = new ISIstructureWiseEntity;
  dvAsCoop = new IsiClientReportDetail;
  dvWithTrust = new ISIstructureWiseEntity;
  dvWithStichting = new ISIstructureWiseEntity;
  dvAsStichting = new IsiClientReportDetail;
  dVBuitendirecteuren = new IsiClientReportDetail;
  getClientWithRealEstate = new IsiClientReportDetail;
  dVWithManagementServices = new IsiClientReportDetail;
  dVWithDomiciliePlus = new IsiClientReportDetail;
  dVWithActAsTrusteeService = new IsiClientReportDetail;
  countryWisePEP = new ISICountryWisePerson;
  countryWiseUBO = new ISICountryWisePerson;
  countryWiseDVs = new ISICountryWiseEntity;

  constructor(private reportService: ReportsService,
              private route: ActivatedRoute) { }

  private getClientForISISub(year, functionName, obj: IsiClientReportDetail, orgId) {
    this.reportService.getClientForISISubReport(functionName, orgId, year)
      .subscribe(clients => {
        obj.clients = clients.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWiseEntitySub(year, functionName, obj: ISICountryWiseEntity, orgId) {
    this.reportService.getCountryWiseEntityForISISubReport(functionName, orgId, year)
      .subscribe(response => {
        obj.data = response.arrResult;
        obj.isLoading = false;
      });
  }

  getPersonForISISub(year, functionName, obj: IsiPersonReportDetail, orgId) {
    this.reportService.getPersonForISISubReport(functionName, orgId, year)
      .subscribe(persons => {
        obj.person = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWisePersonSub(year, functionName, obj: ISICountryWisePerson, orgId) {
    this.reportService.getCountryWisePersonForISISubReport(functionName, orgId, year)
      .subscribe(persons => {
        obj.data = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getStructureWiseEntitySub(year, functionName, obj: ISIstructureWiseEntity, orgId) {
    this.reportService.getStructureWiseEntityForISISubReport(functionName, orgId, year)
      .subscribe(response => {
        obj.data = response.arrResult;
        obj.isLoading = false;
      });
  }

  private loadSubOffice(year) {
    this.allClient.isLoading = true;
    this.getClientForISISub(year, 'getAllClients', this.allClient, this.subOfficeId);
    this.lowRiskBasedDV.isLoading = true;
    this.getClientForISISub(year, 'getLowRiskBasedDV', this.lowRiskBasedDV, this.subOfficeId);
    this.mediumRiskBasedDV.isLoading = true;
    this.getClientForISISub(year, 'getMediumRiskBasedDV', this.mediumRiskBasedDV, this.subOfficeId);
    this.highRiskBasedDV.isLoading = true;
    this.getClientForISISub(year, 'getHighRiskBasedDV', this.highRiskBasedDV, this.subOfficeId);
    this.clientAtYearStart.isLoading = true;
    this.getClientForISISub(year, 'clientsAtStartYear', this.clientAtYearStart, this.subOfficeId);
    this.offBoardedClients.isLoading = true;
    this.getClientForISISub(year, 'offboardedClients', this.offBoardedClients, this.subOfficeId);
    this.newClientsAtYear.isLoading = true;
    this.getClientForISISub(year, 'newClientsAtYear', this.newClientsAtYear, this.subOfficeId);
    this.clientAtYearEnd.isLoading = true;
    this.getClientForISISub(year, 'clientsAtEndYear', this.clientAtYearEnd, this.subOfficeId);
    this.clientFromNetherland.isLoading = true;
    this.getClientForISISub(year, 'getClientFromNetherlands', this.clientFromNetherland, this.subOfficeId);
    this.clientNotFromNetherland.isLoading = true;
    this.getClientForISISub(year, 'getClientNotFromNetherlands', this.clientNotFromNetherland, this.subOfficeId);
    this.uboFromNetherland.isLoading = true;
    this.getPersonForISISub(year, 'getUBOFromNL', this.uboFromNetherland, this.subOfficeId);
    this.uboNotFromNetherland.isLoading = true;
    this.getPersonForISISub(year, 'getUBONotFromNL', this.uboNotFromNetherland, this.subOfficeId);
    this.uboPeps.isLoading = true;
    this.getPersonForISISub(year, 'getPEPUBO', this.uboPeps, this.subOfficeId);
    this.privateStructure.isLoading = true;
    this.getClientForISISub(year, 'getPrivateStructure', this.privateStructure, this.subOfficeId);
    this.bfiClient.isLoading = true;
    this.getClientForISISub(year, 'getBFIClient', this.bfiClient, this.subOfficeId);
    this.fiveLayersClient.isLoading = true;
    this.getClientForISISub(year, 'getDVWithMoreThanFiveLayers', this.fiveLayersClient, this.subOfficeId);
    this.dVWithNomineeShareholders.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getDVWithNomineeShareholders', this.dVWithNomineeShareholders, this.subOfficeId);
    this.dvWithTrustOfficeAsNomineeShareholder.isLoading = true;
    this.getClientForISISub(year, 'getDVWithTrustOfficeAsNomineeShareholder', this.dvWithTrustOfficeAsNomineeShareholder, this.subOfficeId);
    this.dvWithCVOrAlike.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getDVWithCVOrAlike', this.dvWithCVOrAlike, this.subOfficeId);
    this.cvOrAlike.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getCVOrAlike', this.cvOrAlike, this.subOfficeId);
    this.dvAsCoop.isLoading = true;
    this.getClientForISISub(year, 'getDVAsCoop', this.dvAsCoop, this.subOfficeId);
    this.dvWithTrust.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getDVWithTrusts', this.dvWithTrust, this.subOfficeId);
    this.dvWithStichting.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getDVWithStichting', this.dvWithStichting, this.subOfficeId);
    this.dvAsStichting.isLoading = true;
    this.getClientForISISub(year, 'getDVAsStichting', this.dvAsStichting, this.subOfficeId);
    this.dVBuitendirecteuren.isLoading = true;
    this.getClientForISISub(year, 'getDVBuitendirecteuren', this.dVBuitendirecteuren, this.subOfficeId);
    this.getClientWithRealEstate.isLoading = true;
    this.getClientForISISub(year, 'getClientWithRealEstate', this.getClientWithRealEstate, this.subOfficeId);
    this.dVWithManagementServices.isLoading = true;
    this.getClientForISISub(year, 'getDVWithManagementServices', this.dVWithManagementServices, this.subOfficeId);
    this.dVWithDomiciliePlus.isLoading = true;
    this.getClientForISISub(year, 'getDVWithDomiciliePlus', this.dVWithDomiciliePlus, this.subOfficeId);
    this.dVWithActAsTrusteeService.isLoading = true;
    this.getClientForISISub(year, 'getDVWithActAsTrusteeService', this.dVWithActAsTrusteeService, this.subOfficeId);
    this.countryWiseUBO.isLoading = true;
    this.getCountryWisePersonSub(year, 'UBOs', this.countryWiseUBO, this.subOfficeId);
    this.countryWisePEP.isLoading = true;
    this.getCountryWisePersonSub(year, 'peps', this.countryWisePEP, this.subOfficeId);
    this.countryWiseDVs.isLoading = true;
    this.getCountryWiseEntitySub(year, 'address', this.countryWiseDVs, this.subOfficeId);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log(params);
      if (params['year']) {
        this.subOfficeId = params['officeId'];
        this.loadSubOffice(params['year']);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/isi-report-detail-suboffices/isi-report-detail-suboffices.component.ts